import { render, staticRenderFns } from "./BlindFooter.vue?vue&type=template&id=dd56793a&"
import script from "./BlindFooter.vue?vue&type=script&lang=js&"
export * from "./BlindFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports